"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const styles = (0, _makeStyles.default)(theme => {
  var _theme$palette;
  return {
    selectedFilter: {
      display: "flex",
      flexWrap: "wrap",
      [theme.breakpoints.up("md")]: {
        marginTop: theme.spacing(2)
      }
    },
    valueButton: {
      border: "1px solid ".concat((_theme$palette = theme.palette) === null || _theme$palette === void 0 || (_theme$palette = _theme$palette.grey) === null || _theme$palette === void 0 ? void 0 : _theme$palette[200]),
      display: "flex",
      marginBottom: theme.spacing(1),
      marginRight: theme.spacing(1),
      minHeight: 34,
      padding: theme.spacing(0, 1.5)
    },
    clearButton: {
      marginBottom: theme.spacing(1),
      minHeight: 32,
      padding: theme.spacing(0, 1.5)
    },
    label: {
      fontSize: "0.875rem"
    },
    icon: {
      marginLeft: theme.spacing(0.75)
    }
  };
});
var _default = exports.default = styles;